import { render, staticRenderFns } from "./CalendarPicker.vue?vue&type=template&id=271fa576&"
import script from "./CalendarPicker.vue?vue&type=script&lang=js&"
export * from "./CalendarPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/christoph/workspace/nextcloud/apps/calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('271fa576')) {
      api.createRecord('271fa576', component.options)
    } else {
      api.reload('271fa576', component.options)
    }
    module.hot.accept("./CalendarPicker.vue?vue&type=template&id=271fa576&", function () {
      api.rerender('271fa576', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Shared/CalendarPicker.vue"
export default component.exports